import React from 'react';
import Box from '@material-ui/core/Box';

import Typography from '@material-ui/core/Typography';
import CommandIcon from '@material-ui/icons/EventNote';

import { CreateButton } from 'react-admin';

const CommandEmpty = ({ basePath, resource }) => (
  <Box textAlign="center" m={1}>
    <CommandIcon style={{ fontSize: 140 }} />
    <Typography variant="h4" paragraph>
      No commands available yet.
    </Typography>
    <Typography variant="body1">Do you want to add one?</Typography>
    <CreateButton className="primary" basePath={basePath} />
  </Box>
);

export default CommandEmpty;
